var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.764,
    height: 22.102,
    fill: "none",
    style: {
      maxHeight: 500
    },
    viewBox: "0.59 0 22.764 22.102"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E1C6B2",
    d: "m12 0 2.694 8.292h8.719l-7.054 5.124 2.694 8.292L12 16.584l-7.053 5.124 2.694-8.292L.587 8.292h8.719zM39 0l2.694 8.292h8.719l-7.054 5.124 2.694 8.292L39 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719zM66 0l2.694 8.292h8.719l-7.054 5.124 2.694 8.292L66 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719zM93 0l2.694 8.292h8.719l-7.054 5.124 2.694 8.292L93 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719zM120 0l2.694 8.292h8.719l-7.054 5.124 2.694 8.292L120 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719z"
  })));
};
export default SvgStar;